export const actions = {
  ADD_EQUIPMENT: 'ADD_EQUIPMENT',
  ADD_OR_SELECT_EQUIPMENT: 'ADD_OR_SELECT_EQUIPMENT',
  EDIT_EQUIPMENT: 'EDIT_EQUIPMENT',
  NO_DIAGRAMS: 'NO_DIAGRAMS'
};
